import WithLoadingSpinner from '../../../../components/withLoadingSpinner/WithLoadingSpinner';
import RouteCapacityCard from './RouteCapacityCard';
import CourierCard from '../courier/CourierCard';
import { OohCourierTrip, OohRoute } from '../../../../core/graphql/types';

interface OohContentSectionProps {
  selectedRoute: OohRoute | undefined;
  courierTrips: OohCourierTrip[];
  areCourierTripsLoading: boolean;
  selectedCourier: number | null;
  onCourierCardClick: (courierId: number) => void;
}

const OohContentSection = ({
  selectedRoute,
  courierTrips,
  areCourierTripsLoading,
  selectedCourier,
  onCourierCardClick,
}: OohContentSectionProps) => {
  return (
    <>
      {selectedRoute && (
        <div className="mt-6">
          <RouteCapacityCard
            routeName={selectedRoute.routeName!}
            pickupPoints={selectedRoute.oohPoints ?? []}
            courierIndicatives={
              selectedRoute.couriers.map((x) => x.indicative!) ?? []
            }
          />
        </div>
      )}

      <WithLoadingSpinner isLoading={areCourierTripsLoading}>
        {courierTrips.map((courierTrip) => (
          <CourierCard
            key={courierTrip.indicative}
            courierTrip={courierTrip}
            courierClickHandler={onCourierCardClick}
            selectedCourierId={selectedCourier}
          />
        ))}
      </WithLoadingSpinner>
    </>
  );
};

export default OohContentSection;